// Unpublished Work © 2023 Deere & Company.

import t from 'tcomb';

export const CustomerConsentLogs = t.struct({
    contactId: t.Number,
    firstName: t.String,
    middleName: t.String,
    lastName: t.String,
    communicationEntityId: t.Number,
    communicationTypeId: t.String,
    communicationValue: t.String,
    consentSource: t.String,
    consentValue: t.String,
    remark: t.String,
    modifiedBy: t.String,
    timeStamp: t.String
}, {
    defaultProps: {
        contactId: 0,
        firstName: '',
        middleName: '',
        lastName: '',
        communicationEntityId: 0,
        communicationTypeId: '',
        communicationValue: '',
        consentSource: '',
        consentValue: '',
        remark: '',
        modifiedBy: '',
        timeStamp: ''
    },
    name: 'CustomerConsentLogs',
    strict: true
});
